/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-children-prop */
import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';
import useStyles from '../../../assets/styles/pages/User';

// import svg
import { ReactComponent as IconArrow } from '../../../assets/images/svg/sign_up/icon_seta_r.svg';
import { ReactComponent as IconInfo } from '../../../assets/images/svg/utils/info.svg';

import FooterMenuMain from '../../../components/FooterMenuMain';

import CountDownTimer from '../../../components/CountDownTimer';
import Header from '../../../components/Header';
import { getStorege } from '../../../helpers/db_storage';
import { FormatPhone } from '../../../helpers/utils/Formating';
import { useUserUpdateContext } from '../../../providers/use-user-update';
import { useLoadingContext } from '../../../providers/use-loading';
import { api } from '../../../services';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: '10px 25px',
  outline: 'none',
};

const SignUpConfirmPhone: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const { params, id_shop }: any = useParams();
  const userUpdateContext = useUserUpdateContext();
  const { createloading } = useLoadingContext();

  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [openModalNoReciveCode, setOpenModalNoReciveCode] = useState(false);
  const [finishTime, setFinishTime] = useState(false);
  const [dateNowTW, setDateNowTW] = useState<any>();
  const [dataUser, setDataUser] = useState<any>();
  const [modalInfo, setModalInfo] = useState({ title: '', description: '' });
  const [formParams, setFormParams] = useState({
    nrCode1: '',
    nrCode2: '',
    nrCode3: '',
    nrCode4: '',
  });
  const [apiWhatsUse, setApiWhatsUse] = useState<boolean>(true);

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const handleChangeForm = (event: any) => {
    const { name, value, maxLength } = event.target;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [fieldName, fieldIndex] = name.split('-');
    if (value.length >= maxLength) {
      if (parseInt(fieldIndex, 10) < 4) {
        const nextSibling: any = document.querySelector(
          `input[name=nrCode-${parseInt(fieldIndex, 10) + 1}]`,
        );

        // If found, focus the next field
        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    }
    if (value.length < maxLength) {
      if (parseInt(fieldIndex, 10) < 5) {
        const nextSibling: any = document.querySelector(
          `input[name=nrCode-${parseInt(fieldIndex, 10) - 1}]`,
        );
        // If found, focus the next field
        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    }

    setFormParams((field) => {
      return {
        ...field,
        [`nrCode${fieldIndex}`]: value,
      };
    });
  };

  const handleSubimt = async (event: SyntheticEvent) => {
    event.preventDefault();
    if (
      formParams.nrCode1 === '' ||
      formParams.nrCode2 === '' ||
      formParams.nrCode3 === '' ||
      formParams.nrCode4 === ''
    ) {
      setModalInfo({
        title: 'Atenção',
        description: 'Todas as informações são obrigatórias',
      });
      setOpenModalInfo(true);
    }
    if (
      userUpdateContext.data.codeValidation !=
      formParams.nrCode1 +
        formParams.nrCode2 +
        formParams.nrCode3 +
        formParams.nrCode4
    ) {
      setModalInfo({
        title: 'Atenção',
        description: `Código de validação de  ${dataUser?.typeMsgPhone} não é válido!`,
      });
      setOpenModalInfo(true);
      return;
    }
    setModalInfo({
      title: 'Informação',
      description: 'Número telefone validado com suesso!',
    });
    userUpdateContext.setValidation('phone');
    await userUpdateContext.userUpdate(dataUser);
    setOpenModalInfo(true);
    createloading(false);
    if (params && id_shop) {
      handleToPage(`/dashboard/user`);
      return;
    }
    handleToPage('/dashboard/user');
  };

  const handleResendPhone = async (type: string) => {
    createloading(true);
    setOpenModalNoReciveCode(false);
    await userUpdateContext.setPhoneStorage(dataUser, type);
    setModalInfo({
      title: 'Informação',
      description: `Codigo de validação foi enviar por ${type}`,
    });
    setOpenModalInfo(true);
    createloading(false);
  };

  const handleUpdatePhone = () => {
    userUpdateContext.cleanData();

    handleToPage('/dashboard/user/update');
  };

  const handleCheckApiToWhats = async () => {
    try {
      const result: any = await api.apiMaisdelivery.auth.recovePassword({
        nr_operacao: 70,
      });

      if (result.data.status === 'NOK') {
        setApiWhatsUse(false);
      }
    } catch (error) {
      toast.error('Ocorreu erro.');
    }
  };

  useEffect(() => {
    handleCheckApiToWhats();
  }, []);

  useEffect(() => {
    async function finishTimeLinkSendCode() {
      await new Promise((resolve) => {
        setTimeout(resolve, 61000);
      });
      setFinishTime(true);
    }

    finishTimeLinkSendCode();
  }, []);

  useEffect(() => {
    const result = getStorege('@mais/delivery/user/update');

    setDataUser(result);
    setModalInfo({
      title: 'Informação',
      description: `Codigo de validação foi enviado por ${result?.typeMsgPhone}`,
    });
    setOpenModalInfo(true);
  }, []);

  useEffect(() => {
    async function CloseModal() {
      if (openModalInfo) {
        await new Promise((resolve) => {
          setTimeout(resolve, 5000);
        });
        setOpenModalInfo(false);
        setModalInfo({
          title: '',
          description: '',
        });
      }
    }
    CloseModal();
  }, [openModalInfo]);

  useEffect(() => {
    const now = new Date();
    now.setSeconds(now.getSeconds() + 61); // timestamp
    setDateNowTW(new Date(now));
  }, []);

  useEffect(() => {
    if (!userUpdateContext.data.codeValidation) {
      handleToPage('/dashboard/user');
    }
  }, [userUpdateContext.data.codeValidation]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="SignUp" />
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          className={classeStyle.gridForm}
        >
          <form onSubmit={handleSubimt} className={classeStyle.form}>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>
                Digite o código de 4 dígitos que enviamos por{' '}
                {dataUser?.typeMsgPhone}{' '}
                {FormatPhone(`${dataUser?.nrDDD}${dataUser?.nrTelefone}`)}
              </label>
              <Grid item xs={3}>
                <input
                  type="text"
                  className={classeStyle.inputTextCode}
                  name="nrCode-1"
                  value={formParams.nrCode1}
                  onChange={handleChangeForm}
                  minLength={1}
                  maxLength={1}
                />
              </Grid>
              <Grid item xs={3}>
                <input
                  type="text"
                  className={classeStyle.inputTextCode}
                  name="nrCode-2"
                  value={formParams.nrCode2}
                  onChange={handleChangeForm}
                  minLength={1}
                  maxLength={1}
                />
              </Grid>
              <Grid item xs={3}>
                <input
                  type="text"
                  className={classeStyle.inputTextCode}
                  name="nrCode-3"
                  value={formParams.nrCode3}
                  onChange={handleChangeForm}
                  minLength={1}
                  maxLength={1}
                />
              </Grid>
              <Grid item xs={3}>
                <input
                  type="text"
                  className={classeStyle.inputTextCode}
                  name="nrCode-4"
                  value={formParams.nrCode4}
                  onChange={handleChangeForm}
                  minLength={1}
                  maxLength={1}
                />
              </Grid>
            </Grid>
            <Grid
              container
              item
              justifyContent="center"
              alignItems="center"
              textAlign="center"
            >
              <Button
                className={classeStyle.btnSubmit}
                type="submit"
                variant="contained"
              >
                Continuar <IconArrow className={classeStyle.iconSave} />
              </Button>
            </Grid>
            <Grid>
              {finishTime ? (
                <Button
                  color="secondary"
                  onClick={() => setOpenModalNoReciveCode(true)}
                  className={classeStyle.btnNotCodeRecive}
                >
                  Não recebi o código
                </Button>
              ) : (
                <p
                  className={classeStyle.labelText}
                  style={{ textAlign: 'center', marginTop: 20 }}
                >
                  Para reenviar o código, aguarde:{' '}
                  <CountDownTimer children={moment(dateNowTW).format('X')} />
                </p>
              )}
            </Grid>
          </form>
        </Grid>
      </Grid>
      <FooterMenuMain />
      <Modal
        open={openModalInfo}
        onClose={() => setOpenModalInfo(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '500px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              {modalInfo.title}
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {modalInfo.description}
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnModal}
            onClick={() => setOpenModalInfo(false)}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      </Modal>
      <Modal
        open={openModalNoReciveCode}
        onClose={() => setOpenModalNoReciveCode(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '720px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              Não recebeu o código?
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              Veja se digitou o número do seu celular corretamente e <br />
              verifique suas mensagens do {dataUser?.typeMsgPhone} <br />
              {FormatPhone(`${dataUser?.nrDDD}${dataUser?.nrTelefone}`)}
            </Typography>
          </Grid>
          {apiWhatsUse && (
            <Button
              className={classeStyle.btnModal}
              onClick={() => handleResendPhone('WhatsApp')}
              variant="contained"
            >
              Reenviar por WhatsApp
            </Button>
          )}
          <Button
            className={classeStyle.btnModalSegund}
            onClick={() => handleResendPhone('SMS')}
            variant="contained"
          >
            Reenviar por SMS
          </Button>
          <Button
            className={classeStyle.btnModalWhite}
            onClick={() => handleUpdatePhone()}
            variant="contained"
          >
            Alterar o número do telefone
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default SignUpConfirmPhone;
